// extracted by mini-css-extract-plugin
export default {"component":"SignupRoutes_component__v3tV1"};